import React from "react";
import getCodedValue from "../../utils/getCodedValue";

const Disability = ({ data }) => {
  return (
    <div>
      <h4>Disability</h4>
      {data.map((disability, index) => (
        <div key={index}>{getCodedValue(disability.valueCodeableConcept)}</div>
      ))}
    </div>
  );
};

export default Disability;
